import { render } from "./CustomModalContent.vue?vue&type=template&id=48404d31"
import script from "./CustomModalContent.vue?vue&type=script&lang=js"
export * from "./CustomModalContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__